module.exports = "images/apple-icon-114x114.c664213a874bbea67729f0e02d0379b3.png";